// extracted by mini-css-extract-plugin
export default {"fundo":"Login_fundo__qdh5W","logo":"Login_logo__llnAh","inputs":"Login_inputs__khINn","rodape":"Login_rodape__Ql5Wx"};